import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import "../../Styles/Checkout.css";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  getproductbyidRequest,
  getsimilarproductdataRequest,
  insertCartRequest,
} from "../../Containers/Home/Home-slice";
import {
  getaddressRequest,
  addAddressRequest,
} from "../../Containers/Accounts/Account-slice";
import Modal from "../Modal/Modal";
import axiosInstance from "../../utils/AxiosConfig";
import { exitError, showError, showSuccess } from "../../utils/Toast";
import { useNavigate } from "react-router-dom";
import { getCartRequest } from "../../Containers/Home/Home-slice";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import dhiramsymbol from "../../assests/dhirams-png.webp";
import tabbyBadge from "../../assests/tabby-badge.svg";
import {
  DEFAULT_PRODUCT_IMAGE,
  getDisplayPrice,
  getDisplayPricing,
  getProductImage,
  getProductStockQuantity,
  isProductOutOfStock,
} from "../../utils/productPresentation";
import {
  getSafePaymentErrorMessage,
  sanitizeUserPaymentMessage,
} from "../../utils/paymentErrors";
import { openAuthModal } from "../../utils/authModal";
import { getViewportIsMobile } from "../../utils/browser";
import { BUYER_AUTH_EVENT, getBuyerToken } from "../../utils/authStorage";
import { addGuestCartItem } from "../../utils/guestCart";
import {
  COD_MINIMUM_ORDER_MESSAGE,
  isCodAvailableForTotal,
} from "../../utils/paymentRules";
import {
  calculateDeliveryCharge,
  INVALID_UAE_EMIRATE_MESSAGE,
  normalizeUaeEmirate,
} from "../../utils/deliveryRules";
import TabbyCheckoutCard from "../Payments/TabbyCheckoutCard";

function Checkout({
  getproductbyidRequest,
  getproductbyiddata,
  getsimilarproductdataRequest,
  similarproductdata,
  getaddressRequest,
  getaddressData,
  addAddressRequest,
  getCartRequest,
  addAddressData,
  addcartdata,
  insertCartRequest,
}) {
  const location = useLocation();
  const { id, qty = 1, productIdsString, cartItems } = location.state || {};
  const navigate = useNavigate();
  const isDirectCartCheckout =
    !id && !productIdsString && !Array.isArray(cartItems);
  const isCartCheckoutFlow =
    (Array.isArray(cartItems) && cartItems.length > 0) || isDirectCartCheckout;
  const [isMobile, setIsMobile] = useState(false);
  const [tamaraAvailable, setTamaraAvailable] = useState(null);
  const [tabbyConfig, setTabbyConfig] = useState({ available: null });
  const [tabbyEligibility, setTabbyEligibility] = useState({ eligible: true });
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const scrollContainerRef = useRef(null);
  const checkoutStockToastSignatureRef = useRef("");
  const checkoutSubmissionRef = useRef(false);
  const tamaraRequestKeyRef = useRef(null);
  const tabbyRequestKeyRef = useRef(null);
  const hasMountedAddCartToastRef = useRef(false);
  const pendingNewAddressIdRef = useRef(null);

  useEffect(() => {
    let active = true;
    let requestId = 0;
    const checkTamaraAvailability = () => {
      const currentRequest = ++requestId;
      if (!getBuyerToken()) {
        setTamaraAvailable(false);
        return;
      }
      setTamaraAvailable(null);
      axiosInstance.get("/tamara/availability")
        .then((response) => {
          if (active && currentRequest === requestId) {
            setTamaraAvailable(response.data?.available === true);
          }
        })
        .catch(() => {
          if (active && currentRequest === requestId) setTamaraAvailable(false);
        });
    };
    checkTamaraAvailability();
    window.addEventListener(BUYER_AUTH_EVENT, checkTamaraAvailability);
    return () => {
      active = false;
      window.removeEventListener(BUYER_AUTH_EVENT, checkTamaraAvailability);
    };
  }, []);

  useEffect(() => {
    let active = true;
    let requestId = 0;
    const checkTabbyAvailability = () => {
      const currentRequest = ++requestId;
      if (!getBuyerToken()) {
        setTabbyConfig({ available: false });
        return;
      }
      setTabbyConfig({ available: null });
      axiosInstance.get("/tabby/availability")
        .then(({ data }) => {
          if (active && currentRequest === requestId) {
            setTabbyConfig({ available: data?.available === true, publicKey: data?.public_key, merchantCode: data?.merchant_code });
          }
        })
        .catch(() => {
          if (active && currentRequest === requestId) setTabbyConfig({ available: false });
        });
    };
    checkTabbyAvailability();
    window.addEventListener(BUYER_AUTH_EVENT, checkTabbyAvailability);
    return () => {
      active = false;
      window.removeEventListener(BUYER_AUTH_EVENT, checkTabbyAvailability);
    };
  }, []);

  const normalizeCheckoutProduct = useCallback((product) => {
    const productId = Number(product?.product_id ?? product?.id ?? 0);

    if (!productId) {
      return null;
    }

    return {
      ...product,
      id: productId,
      product_id: productId,
      name: product.name || product.product_name || "",
      cart_id: product?.cart_id ?? product?.id ?? null,
    };
  }, []);

  // Check screen size for mobile
  useEffect(() => {
    setIsMobile(getViewportIsMobile());

    const handleResize = () => {
      setIsMobile(getViewportIsMobile());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Check scroll arrows visibility
  const checkScrollArrows = () => {
    if (scrollContainerRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } =
        scrollContainerRef.current;
      setShowLeftArrow(scrollLeft > 10);
      setShowRightArrow(scrollLeft + clientWidth < scrollWidth - 10);
    }
  };

  useEffect(() => {
    checkScrollArrows();
    window.addEventListener("resize", checkScrollArrows);
    return () => window.removeEventListener("resize", checkScrollArrows);
  }, [similarproductdata]);

  const scrollSuggested = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = isMobile ? 250 : 300;
      scrollContainerRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const [products, setProducts] = useState([]);
  const [quantities, setQuantities] = useState({});
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [selectedShippingAddressId, setSelectedShippingAddressId] =
    useState(null);
  const [selectedBillingAddressId, setSelectedBillingAddressId] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [addressError, setAddressError] = useState("");

  useEffect(() => {
    if (!getBuyerToken()) {
      openAuthModal({ returnTo: "/checkout" });
    }
  }, []);

  useEffect(() => {
    const hasMobileBottomButton = isMobile && currentStep === 3;
    document.body.classList.toggle(
      "has-mobile-bottom-btn",
      hasMobileBottomButton,
    );

    return () => document.body.classList.remove("has-mobile-bottom-btn");
  }, [currentStep, isMobile]);

  const [addressForm, setAddressForm] = useState({
    address_line1: "",
    address_line2: "",
    city: "",
    state: "",
    pincode: "",
    country: "UAE",
    phone: "",
    address_type: "shipping",
  });

  const resetAddressForm = useCallback(() => {
    setAddressForm({
      address_line1: "",
      address_line2: "",
      city: "",
      state: "",
      pincode: "",
      country: "UAE",
      phone: "",
      address_type: "shipping",
    });
  }, []);

  const closeAddressFormModal = useCallback(() => {
    setShowAddressForm(false);
  }, []);

  const UAE_EMIRATES = [
    "Abu Dhabi",
    "Dubai",
    "Sharjah",
    "Ajman",
    "Fujairah",
    "Ras Al Khaimah",
    "Umm Al Quwain",
  ];

  const UAE_CITIES_BY_EMIRATE = {
    "Abu Dhabi": ["Abu Dhabi", "Al Ain", "Al Dhafra"],
    Dubai: ["Dubai"],
    Sharjah: ["Sharjah", "Khor Fakkan", "Dibba Al-Hisn", "Kalba"],
    Ajman: ["Ajman", "Manama", "Masfout"],
    Fujairah: ["Fujairah", "Dibba Al-Fujairah"],
    "Ras Al Khaimah": ["Ras Al Khaimah", "Al Jazirah Al Hamra"],
    "Umm Al Quwain": ["Umm Al Quwain"],
  };

  const getCitiesForEmirate = (emirate) => UAE_CITIES_BY_EMIRATE[emirate] || [];

  const applyCheckoutProducts = useCallback(
    (nextProducts = []) => {
      const normalizedProducts = nextProducts
        .map((product) => normalizeCheckoutProduct(product))
        .filter(Boolean);

      setProducts(normalizedProducts);

      const initialQuantities = {};
      normalizedProducts.forEach((product) => {
        if (isCartCheckoutFlow) {
          initialQuantities[product.id] = Number(product.quantity || 1);
        } else {
          initialQuantities[product.id] = product.id === Number(id) ? Number(qty || 1) : 1;
        }
      });
      setQuantities(initialQuantities);

      return normalizedProducts;
    },
    [id, isCartCheckoutFlow, normalizeCheckoutProduct, qty],
  );

  const fetchLatestCheckoutProducts = useCallback(async () => {
    if (isCartCheckoutFlow) {
      const response = await axiosInstance.get("getCart");
      const latestProducts = Array.isArray(response.data?.data)
        ? response.data.data
        : [];
      const normalizedProducts = applyCheckoutProducts(latestProducts);

      if (!normalizedProducts.length) {
        navigate("/cart", { replace: true });
      }

      return normalizedProducts;
    }

    if (!productIdsString) {
      return [];
    }

    const response = await axiosInstance.get(`getProductById/${productIdsString}`);
    const latestProducts = Array.isArray(response.data?.data)
      ? response.data.data
      : Array.isArray(response.data)
        ? response.data
        : [];

    return applyCheckoutProducts(latestProducts);
  }, [
    applyCheckoutProducts,
    isCartCheckoutFlow,
    navigate,
    productIdsString,
  ]);

  /* =========================
     FETCH DATA
  ========================= */
  useEffect(() => {
    if (!getBuyerToken()) {
      return;
    }

    if (isCartCheckoutFlow) {
      fetchLatestCheckoutProducts().catch(() => {
        showError("Unable to load your latest cart. Please try again.");
        navigate("/cart", { replace: true });
      });
    } else if (productIdsString) {
      getproductbyidRequest(productIdsString);
    }
    getaddressRequest();
  }, [
    fetchLatestCheckoutProducts,
    getaddressRequest,
    getproductbyidRequest,
    isCartCheckoutFlow,
    navigate,
    productIdsString,
  ]);

  useEffect(() => {
    if (isCartCheckoutFlow || !getproductbyiddata?.length) {
      return;
    }

    applyCheckoutProducts(getproductbyiddata);
  }, [applyCheckoutProducts, getproductbyiddata, isCartCheckoutFlow]);

  useEffect(() => {
    if (addAddressData) {
      const nextAddressId = Number(addAddressData?.data?.address_id || 0);
      if (nextAddressId > 0) {
        pendingNewAddressIdRef.current = nextAddressId;
      }
      getaddressRequest();
    }
  }, [addAddressData, getaddressRequest]);

  useEffect(() => {
    if (!products.length) return;
    const seedId = products[0]?.id || id;
    if (seedId) {
      getsimilarproductdataRequest(seedId);
    }
  }, [products, id, getsimilarproductdataRequest]);

  useEffect(() => {
    if (!hasMountedAddCartToastRef.current) {
      hasMountedAddCartToastRef.current = true;
      return;
    }

    if (!addcartdata) return;
    if (addcartdata.success) {
      showSuccess(addcartdata.message);
      getCartRequest();
    }
  }, [addcartdata, getCartRequest]);

  /* =========================
     PRICE CALCULATION
  ========================= */
  const pricing = useMemo(() => {
    if (!products.length) return null;

    let originalTotal = 0;
    let totalDiscount = 0;
    let subtotal = 0;
    let totalAmount = 0;

    products.forEach((product) => {
      const pricingDetails = getDisplayPricing(product);
      const unitPrice = pricingDetails.originalPrice;
      const discountPerUnit = pricingDetails.discountAmount;
      const discountedUnitPrice = pricingDetails.finalPrice;
      const quantity = quantities[product.id] || 1;

      const productOriginalTotal = unitPrice * quantity;
      const productDiscount = discountPerUnit * quantity;
      const productSubtotal = discountedUnitPrice * quantity;

      originalTotal += productOriginalTotal;
      totalDiscount += productDiscount;
      subtotal += productSubtotal;
      totalAmount += productSubtotal;
    });

    return {
      originalTotal,
      totalDiscount,
      subtotal,
      vatAmount: 0,
      total: totalAmount,
      isMultiple: products.length > 1,
    };
  }, [products, quantities]);

  /* =========================
     ADDRESS HANDLERS
  ========================= */
  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    setAddressForm((prev) => ({
      ...prev,
      [name]: value,
    }));
    setAddressError("");
  };

  const handlePhoneChange = (value, country) => {
    setAddressForm((prev) => ({
      ...prev,
      phone: value,
    }));
    setAddressError("");
  };

  const validateAddressForm = () => {
    if (!addressForm.address_line1.trim()) {
      setAddressError("Address line 1 is required");
      return false;
    }
    if (!addressForm.city.trim()) {
      setAddressError("City is required");
      return false;
    }
    if (!addressForm.state.trim()) {
      setAddressError("State is required");
      return false;
    }
    if (!addressForm.phone.trim()) {
      setAddressError("Phone number is required");
      return false;
    }
    if (addressForm.phone.length < 8) {
      setAddressError("Please enter a valid phone number");
      return false;
    }
    return true;
  };

  const onclickaddress = async () => {
    if (!validateAddressForm()) {
      return;
    }

    try {
      setIsLoading(true);
      await addAddressRequest({
        ...addressForm,
        pincode: addressForm.pincode.trim() || null,
      });
      showSuccess("Address added successfully");
      getaddressRequest();
      setShowAddressForm(false);
      resetAddressForm();
    } catch (error) {
      showError("Failed to add address");
    } finally {
      setIsLoading(false);
    }
  };

  const onclickcancel = () => {
    setShowAddressForm(false);
    setAddressError("");
    resetAddressForm();
  };

  const handleAddressSelection = (addrId) => {
    setSelectedAddressId(addrId);
    setSelectedShippingAddressId(addrId);
    setSelectedBillingAddressId(addrId);
    setAddressError("");
  };

  const getSavedAddressId = useCallback((address) => {
    const rawId =
      address?.profile_id ??
      address?.address_id ??
      address?.user_profile_id ??
      address?.id ??
      null;
    const normalizedId = Number(rawId);
    return Number.isFinite(normalizedId) && normalizedId > 0 ? normalizedId : null;
  }, []);

  const savedAddresses = useMemo(
    () =>
      Array.isArray(getaddressData?.data)
        ? getaddressData.data.filter(
            (addr) => addr?.address && String(addr.address).trim() !== "",
          )
        : [],
    [getaddressData],
  );

  const addressMap = useMemo(() => {
    const nextMap = new Map();

    savedAddresses.forEach((address) => {
      const savedAddressId = getSavedAddressId(address);
      if (savedAddressId) {
        nextMap.set(savedAddressId, address);
      }
    });

    return nextMap;
  }, [getSavedAddressId, savedAddresses]);

  const defaultAddressId = useMemo(() => {
    const defaultAddress = savedAddresses.find(
      (address) =>
        Number(address?.is_default_address || 0) === 1 &&
        normalizeUaeEmirate(address?.state),
    );

    return defaultAddress ? getSavedAddressId(defaultAddress) : null;
  }, [getSavedAddressId, savedAddresses]);

  const selectedDeliveryAddress = useMemo(
    () =>
      addressMap.get(
        Number(selectedShippingAddressId || selectedAddressId || 0),
      ) || null,
    [addressMap, selectedAddressId, selectedShippingAddressId],
  );

  const selectedDeliveryEmirate = normalizeUaeEmirate(
    selectedDeliveryAddress?.state,
  );

  const deliveryCharge =
    pricing && selectedDeliveryAddress && selectedDeliveryEmirate
      ? calculateDeliveryCharge({
          subtotal: pricing.subtotal,
          emirate: selectedDeliveryAddress.state,
        })
      : null;

  const payableTotal =
    pricing && deliveryCharge !== null ? pricing.total + deliveryCharge : null;

  const isCodEligible = pricing
    ? isCodAvailableForTotal(payableTotal ?? pricing.total)
    : false;
  const shouldShowCodMinimumMessage = Boolean(pricing) && !isCodEligible;
  const tabbySelectable = tabbyConfig.available === true && tabbyEligibility.eligible !== false;

  useEffect(() => {
    if (currentStep !== 3 || tabbyConfig.available !== true || !selectedShippingAddressId || !payableTotal) return undefined;
    let active = true;
    setTabbyEligibility({ eligible: true, checking: true });
    const timer = window.setTimeout(() => {
      axiosInstance.post("/tabby/pre-score", { amount: payableTotal, shipping_address_id: selectedShippingAddressId })
        .then(({ data }) => {
          if (active) setTabbyEligibility({ eligible: data?.eligible !== false, message: data?.message || "" });
        })
        .catch(() => {
          if (active) setTabbyEligibility({ eligible: true });
        });
    }, 500);
    return () => { active = false; window.clearTimeout(timer); };
  }, [currentStep, tabbyConfig.available, selectedShippingAddressId, payableTotal]);

  useEffect(() => {
    if (paymentMethod === "tabby" && !tabbySelectable) setPaymentMethod(null);
  }, [paymentMethod, tabbySelectable]);

  useEffect(() => {
    if (paymentMethod === "cod" && !isCodEligible) {
      setPaymentMethod(null);
    }
  }, [isCodEligible, paymentMethod]);

  useEffect(() => {
    const pendingAddressId = Number(pendingNewAddressIdRef.current || 0);
    if (pendingAddressId && addressMap.has(pendingAddressId)) {
      setSelectedAddressId(pendingAddressId);
      setSelectedShippingAddressId(pendingAddressId);
      setSelectedBillingAddressId(pendingAddressId);
      setAddressError("");
      pendingNewAddressIdRef.current = null;
      return;
    }

    const currentSelectedId = Number(selectedAddressId || 0);
    if (currentSelectedId && addressMap.has(currentSelectedId)) {
      return;
    }

    if (defaultAddressId) {
      setSelectedAddressId(defaultAddressId);
      setSelectedShippingAddressId(defaultAddressId);
      setSelectedBillingAddressId(defaultAddressId);
      setAddressError("");
      return;
    }

    if (currentSelectedId && !addressMap.has(currentSelectedId)) {
      setSelectedAddressId(null);
      setSelectedShippingAddressId(null);
      setSelectedBillingAddressId(null);
    }
  }, [addressMap, defaultAddressId, selectedAddressId]);

  const handleNextToPayment = () => {
    if (hasCheckoutStockIssue) {
      handleCheckoutStockFailure({
        message:
          "Some products in your cart are out of stock. Please update your cart.",
      });
      return;
    }

    if (!selectedAddressId) {
      setAddressError("Please select a delivery address");
      return;
    }

    if (!selectedDeliveryEmirate || deliveryCharge === null) {
      setAddressError(INVALID_UAE_EMIRATE_MESSAGE);
      return;
    }
    setCurrentStep(3);
    setAddressError("");
  };

  const format = (n) => Number(n).toFixed(2);

  const AmountWithDirham = ({ amount, className = "", negative = false }) => (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        verticalAlign: "middle",
      }}
    >
      {negative ? <span>-</span> : null}
      <img
        src={dhiramsymbol}
        alt="AED"
        width={14}
        height={14}
        style={{
          width: "14px",
          height: "14px",
          objectFit: "contain",
          flexShrink: 0,
        }}
      />
      <span>{format(amount)}</span>
    </span>
  );

  function numberWithCommas(x) {
    if (x == null || Number.isNaN(Number(x))) return "";
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const getProductStock = (product) => {
    const parsed = Number(getProductStockQuantity(product));
    return Number.isFinite(parsed) ? Math.max(0, Math.floor(parsed)) : null;
  };

  const getCheckoutStockValidation = useCallback(
    (productList = products, quantityMap = quantities) => {
      for (const product of productList) {
        const quantity = Number(quantityMap?.[product.id] || 1);

        if (!Number.isInteger(quantity) || quantity < 1) {
          return {
            isValid: false,
            message: `${product.name}: Quantity must be at least 1`,
          };
        }

        if (isProductOutOfStock(product)) {
          return {
            isValid: false,
            message: "Some products in your cart are out of stock. Please update your cart.",
          };
        }

        const stock = getProductStock(product);
        if (stock !== null && quantity > stock) {
          return {
            isValid: false,
            message: "Some products in your cart are out of stock. Please update your cart.",
          };
        }
      }

      return { isValid: true, message: "" };
    },
    [products, quantities],
  );

  const checkoutStockValidation = useMemo(
    () => getCheckoutStockValidation(products, quantities),
    [getCheckoutStockValidation, products, quantities],
  );
  const hasCheckoutStockIssue = !checkoutStockValidation.isValid;

  const handleCheckoutStockFailure = useCallback(
    (payload = null) => {
      const message =
        payload?.message ||
        "Some products in your cart are out of stock. Please update your cart.";

      showError(message);
      getCartRequest();

      if (isCartCheckoutFlow) {
        navigate("/cart", { replace: true });
      }
    },
    [getCartRequest, isCartCheckoutFlow, navigate],
  );

  useEffect(() => {
    if (!products.length || checkoutStockValidation.isValid) {
      checkoutStockToastSignatureRef.current = "";
      return;
    }

    const signature = `${checkoutStockValidation.message}|${products
      .map((product) => `${product.id}:${quantities[product.id] || 1}`)
      .join(",")}`;

    if (checkoutStockToastSignatureRef.current === signature) {
      return;
    }

    checkoutStockToastSignatureRef.current = signature;
    showError(checkoutStockValidation.message);

    if (isCartCheckoutFlow) {
      getCartRequest();
      navigate("/cart", { replace: true });
    }
  }, [
    checkoutStockValidation,
    getCartRequest,
    isCartCheckoutFlow,
    navigate,
    products,
    quantities,
  ]);

  const onclickcart = (data) => {
    if (isProductOutOfStock(data)) {
      showError("This product is currently out of stock.");
      return;
    }

    const pricingDetails = getDisplayPricing(data);
    const payload = {
      product_id: data?.id ?? data?.product_id,
      quantity: data?.quantity ? Number(data.quantity) : 1,
      price: Number(getDisplayPrice(data) ?? 0),
      discount: Number(data?.discount ?? 0),
      attributes: data.attributes,
    };
    if (pricingDetails.hasOffer) {
      payload.offer_id = pricingDetails.offerId;
      payload.original_price = pricingDetails.originalPrice;
      payload.offer_price = pricingDetails.finalPrice;
      payload.offer_discount_amount = pricingDetails.discountAmount;
    }

    if (!getBuyerToken()) {
      addGuestCartItem(payload);
      showSuccess("Cart Added Successfully");
      return;
    }

    insertCartRequest(payload);
  };

  const SuggestedProductCard = ({ product }) => {
    const pricingDetails = getDisplayPricing(product);
    const discount = parseFloat(product.discount) || 0;
    const oldPrice =
      pricingDetails.hasOffer || discount > 0 ? pricingDetails.originalPrice : null;
    const currentPrice = pricingDetails.finalPrice;
    const formatPrice = (value) => numberWithCommas(Number(value).toFixed(2));
    const outOfStock = isProductOutOfStock(product);

    return (
      <article className="ds-product-card ds-product-card-hover cart-suggest-card">
        <div className="ds-product-card-media cart-suggest-card__media">
          {outOfStock && (
            <div className="pcard-badge-orange">Out of Stock</div>
          )}
          {pricingDetails.hasOffer ? (
            <div className="ds-product-card-badge">
              Save AED {formatPrice(pricingDetails.discountAmount)}
            </div>
          ) : discount > 0 ? (
            <div className="ds-product-card-badge">{discount}% OFF</div>
          ) : null}
          <img
            src={getProductImage(product)}
            alt={product.name}
            onError={(event) => {
              event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
            }}
          />
        </div>

        <div className="cart-suggest-card__body">
          <p className="ds-product-card-name cart-suggest-card__name">
            {product.name}
          </p>

          <div className="ds-product-card-prices cart-suggest-card__prices">
            <span className="ds-product-card-price cart-suggest-card__price">
              <img
                src={dhiramsymbol}
                width={18}
                height={18}
                alt="Dirham"
                className="cart-suggest-card__currency"
              />
              <span>{formatPrice(currentPrice)}</span>
            </span>
            {oldPrice && (
              <span className="ds-product-card-old-price cart-suggest-card__old-price">
                {formatPrice(oldPrice)}
              </span>
            )}
          </div>

          <button
            type="button"
            className="ds-product-card-btn cart-suggest-card__btn"
            disabled={outOfStock}
            style={outOfStock ? { opacity: 0.7, cursor: "not-allowed" } : undefined}
            onClick={(e) => {
              e.stopPropagation();
              onclickcart(product);
            }}
          >
            {outOfStock ? "Out of Stock" : "Add to Cart"}
          </button>
        </div>
      </article>
    );
  };

  const renderSummaryAmount = (
    amount,
    {
      fallbackText = "Calculated after address",
      fallbackClassName = "checkout-summary-status",
      freeClassName = "checkout-summary-free",
      amountClassName = "",
    } = {},
  ) => {
    if (amount === null || amount === undefined) {
      return <span className={fallbackClassName}>{fallbackText}</span>;
    }

    if (Number(amount) === 0) {
      return <span className={freeClassName}>FREE</span>;
    }

    return <AmountWithDirham amount={amount} className={amountClassName} />;
  };

  /* =========================
     ORDER CONFIRMATION
  ========================= */
  const showCheckoutPaymentError = (message) => {
    if ((paymentMethod === "tamara" || paymentMethod === "tabby") && message.includes("first and last name in My Account")) {
      exitError(
        <span>
          {message}{" "}
          <a
            href="/account"
            className="checkout-profile-link"
            onClick={(event) => {
              event.preventDefault();
              navigate("/account", { state: { navigationname: "profile" } });
            }}
          >
            Open Profile
          </a>
        </span>,
      );
      return;
    }
    showError(message);
  };

  const handleConfirmOrder = async () => {
    if (isLoading || checkoutSubmissionRef.current) return;

    if (hasCheckoutStockIssue) {
      handleCheckoutStockFailure({
        message:
          "Some products in your cart are out of stock. Please update your cart.",
      });
      return;
    }

    if (!selectedShippingAddressId) {
      setAddressError("Please select a delivery address");
      setCurrentStep(2);
      return;
    }

    if (!selectedDeliveryEmirate || deliveryCharge === null) {
      setAddressError(INVALID_UAE_EMIRATE_MESSAGE);
      setCurrentStep(2);
      showError(INVALID_UAE_EMIRATE_MESSAGE);
      return;
    }

    if (!paymentMethod) {
      showError("Please select a payment method");
      return;
    }

    if (paymentMethod === "cod" && !isCodEligible) {
      showError(COD_MINIMUM_ORDER_MESSAGE);
      return;
    }

    if (paymentMethod === "tamara" && tamaraAvailable !== true) {
      showError("Tamara payment is currently unavailable. Please choose another payment method.");
      return;
    }
    if (paymentMethod === "tabby" && !tabbySelectable) {
      showError(tabbyEligibility.message || "Tabby payment is currently unavailable. Please choose another payment method.");
      return;
    }

    checkoutSubmissionRef.current = true;
    setIsLoading(true);

    try {
      const token = getBuyerToken();

      if (!token) {
        showError("Please login to place order");
        navigate("/login");
        return;
      }

      const latestProducts = await fetchLatestCheckoutProducts();
      const productsToValidate =
        Array.isArray(latestProducts) && latestProducts.length
          ? latestProducts
          : products;

      const latestStockValidation = getCheckoutStockValidation(
        productsToValidate,
        quantities,
      );
      if (!latestStockValidation.isValid) {
        handleCheckoutStockFailure({
          message: latestStockValidation.message,
        });
        return;
      }

      for (const product of productsToValidate) {
        const quantity = quantities[product.id] || 1;
        if (quantity < 1) {
          showError(`${product.name}: Quantity must be at least 1`);
          setIsLoading(false);
          return;
        }

        if (isProductOutOfStock(product)) {
          showError(`Product is out of stock: ${product.name}`);
          setIsLoading(false);
          return;
        }

        const stock = getProductStock(product);
        if (stock !== null) {
          if (stock < 1) {
            showError(`${product.name}: Out of stock`);
            setIsLoading(false);
            return;
          }
          if (quantity > stock) {
            showError(
              `${product.name}: Only ${stock} items available in stock`,
            );
            setIsLoading(false);
            return;
          }
        }
      }

      const orderItems = productsToValidate.map((product) => {
        const pricingDetails = getDisplayPricing(product);
        const quantity = quantities[product.id] || 1;

        const orderItem = {
          product_id: product.id,
          quantity: quantity,
          unit_price: pricingDetails.originalPrice,
          discount: pricingDetails.discountAmount,
          attributes: {
            name: product.name,
            sku: product.sku || "",
            image_url: product.singleImage,
          },
        };

        if (pricingDetails.hasOffer) {
          orderItem.offer_id = pricingDetails.offerId;
          orderItem.original_price = pricingDetails.originalPrice;
          orderItem.offer_price = pricingDetails.finalPrice;
          orderItem.offer_discount_amount = pricingDetails.discountAmount;
        }

        return orderItem;
      });

      const orderPaymentMethod = {
        online: "stripe",
        tamara: "tamara",
        tabby: "tabby",
        cod: "cod",
      }[paymentMethod];

      const orderData = {
        fromCart: isCartCheckoutFlow,
        items: isCartCheckoutFlow ? [] : orderItems,
        shipping_address_id: selectedShippingAddressId,
        billing_address_id:
          selectedBillingAddressId || selectedShippingAddressId,
        payment_method: orderPaymentMethod,
        metadata: {
          payment_method: orderPaymentMethod,
          order_type: isCartCheckoutFlow ? "cart_checkout" : "direct_purchase",
          total_items: productsToValidate.length,
          total_amount: payableTotal ?? pricing.total,
          quantities: quantities,
        },
      };

      if (paymentMethod === "tamara") {
        if (!tamaraRequestKeyRef.current) {
          tamaraRequestKeyRef.current = window.crypto.randomUUID();
        }
        orderData.checkout_request_id = tamaraRequestKeyRef.current;
      }
      if (paymentMethod === "tabby") {
        if (!tabbyRequestKeyRef.current) tabbyRequestKeyRef.current = window.crypto.randomUUID();
        orderData.checkout_request_id = tabbyRequestKeyRef.current;
      }

      if (["online", "tamara", "tabby"].includes(paymentMethod)) {
        const response = await axiosInstance.post(
          paymentMethod === "tamara"
            ? "/tamara/create-checkout-session"
            : paymentMethod === "tabby"
              ? "/tabby/create-checkout-session"
            : "/stripe/create-checkout-session",
          orderData,
        );

        if (response.data?.status && response.data?.checkout_url) {
          if (paymentMethod === "online") getCartRequest();
          window.location.href = response.data.checkout_url;
          return;
        }

        if (Array.isArray(response.data?.stock_errors) && response.data.stock_errors.length) {
          handleCheckoutStockFailure(response.data);
          return;
        }

        showCheckoutPaymentError(
          sanitizeUserPaymentMessage(
            response.data?.message,
            "Payment could not be started. Please try again.",
          ),
        );
        return;
      }

      const response = await axiosInstance.post("/orders", orderData);

      if (Array.isArray(response.data?.stock_errors) && response.data.stock_errors.length) {
        handleCheckoutStockFailure(response.data);
        return;
      }

      if (!response.data?.success) {
        showError(response.data?.message || "Failed to place order");
        return;
      }

      showSuccess("Order placed successfully!");
      getCartRequest();

      navigate("/userorder", {
        state: {
          orderId: response.data.order_id,
          orderNumber: response.data.order_number,
          total: response.data.total_amount,
          tracking_number: response.data.tracking_number,
          quantities: quantities,
        },
      });
    } catch (error) {
      console.error("Error placing order:", error);

      if (Array.isArray(error.response?.data?.stock_errors) && error.response.data.stock_errors.length) {
        handleCheckoutStockFailure(error.response.data);
        return;
      }

      const failedOrderId = Number(error.response?.data?.order_id || 0);
      if (failedOrderId) {
        navigate(`/userorder/${failedOrderId}`, {
          state: {
            orderId: failedOrderId,
          },
        });
      }

      showCheckoutPaymentError(
        ["online", "tamara", "tabby"].includes(paymentMethod)
          ? getSafePaymentErrorMessage(
              error,
              paymentMethod === "tamara"
                ? "Tamara payment could not be started. Please try again."
                : paymentMethod === "tabby"
                  ? "Tabby payment could not be started. Please try again."
                : "Payment could not be started. Please try again.",
            )
          : sanitizeUserPaymentMessage(
              error?.response?.data?.message || error?.message,
              "An error occurred while placing your order. Please try again.",
            ),
      );
    } finally {
      checkoutSubmissionRef.current = false;
      setIsLoading(false);
    }
  };

  // Mobile Stepper Component
  const MobileStepper = () => (
    <div className="mobile-stepper">
      <div className="mobile-step-items">
        <div
          className={`mobile-step-item ${currentStep === 1 ? "active" : ""} ${currentStep > 1 ? "completed" : ""}`}
          onClick={() => setCurrentStep(1)}
        >
          <div className="mobile-step-circle">
            {currentStep > 1 ? "✓" : "1"}
          </div>
          <span>Order Summary</span>
        </div>
        <div className="mobile-step-line" />
        <div
          className={`mobile-step-item ${currentStep === 2 ? "active" : ""} ${currentStep > 2 ? "completed" : ""}`}
          onClick={() => setCurrentStep(2)}
        >
          <div className="mobile-step-circle">
            {currentStep > 2 ? "✓" : "2"}
          </div>
          <span>Address</span>
        </div>
        <div className="mobile-step-line" />
        <div
          className={`mobile-step-item ${currentStep === 3 ? "active" : ""}`}
          onClick={() => setCurrentStep(3)}
        >
          <div className="mobile-step-circle">3</div>
          <span>Payment</span>
        </div>
      </div>
    </div>
  );

  if (!products.length || !pricing)
    return <div className="loading">Loading...</div>;

  return (
    <div className="checkout-page">
      <h1 className="checkout-title">Checkout</h1>

      {/* Desktop Stepper */}
      {!isMobile && (
        <div className="checkout-stepper">
          <div className="step-wrapper">
            <div className={`step ${currentStep === 1 ? "active" : ""}`}>
              <div className="circle">1</div>
              <span>Order Summary</span>
            </div>
            <div className="line" />
          </div>

          <div className="step-wrapper">
            <div className={`step ${currentStep === 2 ? "active" : ""}`}>
              <div className="circle">2</div>
              <span>Delivery Address</span>
            </div>
            <div className="line" />
          </div>

          <div className={`step ${currentStep === 3 ? "active" : ""}`}>
            <div className="circle">3</div>
            <span>Payment</span>
          </div>
        </div>
      )}

      {/* Mobile Stepper */}
      {isMobile && <MobileStepper />}

      {/* CONTENT */}
      <div className="checkout-content">
        {/* LEFT SECTION */}
        <div className="checkout-left">
          {hasCheckoutStockIssue && (
            <div className="error-message">
              Some products in your cart are out of stock. Please update your cart.
            </div>
          )}

          {/* STEP 1 – ORDER SUMMARY */}
          {currentStep === 1 && (
            <>
              <h2>
                Order Summary{" "}
                {products.length > 1 && `(${products.length} items)`}
              </h2>

              <div className="checkout-order-items">
                {products.map((product) => {
                  const pricingDetails = getDisplayPricing(product);
                  const unitPrice = pricingDetails.originalPrice;
                  const discountPerUnit = pricingDetails.discountAmount;
                  const quantity = quantities[product.id] || 1;
                  const productTotal = pricingDetails.finalPrice * quantity;

                  return (
                    <article key={product.id} className="checkout-order-card">
                      <div className="checkout-order-card__media">
                        <img
                          src={getProductImage(product)}
                          alt={product.name || "Product"}
                          onError={(event) => {
                            event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
                          }}
                        />
                      </div>
                      <div className="checkout-order-card__details">
                        <h3 className="checkout-order-card__name">{product.name || `Product #${product.id}`}</h3>
                        <div className="checkout-order-card__meta">
                          <span>Quantity: <strong>{quantity}</strong></span>
                          <span>Unit Price: <strong><AmountWithDirham amount={unitPrice} /></strong></span>
                        </div>
                        {pricingDetails.hasOffer ? (
                          <p className="checkout-order-card__adjustment">
                            Offer Savings: <AmountWithDirham amount={discountPerUnit} /> / unit
                          </p>
                        ) : pricingDetails.discountPercent > 0 ? (
                          <p className="checkout-order-card__adjustment">
                            Discount: {pricingDetails.discountPercent}% (
                            <AmountWithDirham amount={discountPerUnit} /> / unit)
                          </p>
                        ) : null}
                        {pricingDetails.hasOffer && (
                          <p className="checkout-order-card__offer-price">
                            Offer price: <AmountWithDirham amount={pricingDetails.finalPrice} />
                          </p>
                        )}
                      </div>
                      <div className="checkout-order-card__total">
                        <span>Item total</span>
                        <strong><AmountWithDirham amount={productTotal} /></strong>
                        {(pricingDetails.hasOffer || pricingDetails.discountPercent > 0) && (
                          <s><AmountWithDirham amount={unitPrice * quantity} /></s>
                        )}
                      </div>
                    </article>
                  );
                })}
              </div>
            </>
          )}

          {/* STEP 2 – ADDRESS */}
          {currentStep === 2 && (
            <>
              <h2>Delivery Address</h2>

              {addressError && (
                <div className="error-message">{addressError}</div>
              )}

              {savedAddresses.length > 0 ? (
                <div className="saved-address-wrapper">
                  {savedAddresses.map((addr) => {
                      const savedAddressId = getSavedAddressId(addr);
                      if (!savedAddressId) return null;

                      return (
                        <div
                          key={savedAddressId}
                          className="saved-address-card"
                          onClick={() => handleAddressSelection(savedAddressId)}
                        >
                          <label className="saved-address-label">
                            <input
                              type="radio"
                              name="selectedAddress"
                              value={savedAddressId}
                              checked={selectedAddressId === savedAddressId}
                              onChange={() => handleAddressSelection(savedAddressId)}
                              onClick={(e) => e.stopPropagation()}
                            />
                            <div className="saved-address-content">
                              <p className="address-text">{addr.address}</p>
                              <p className="address-sub">
                                {addr.city} {addr.state} {addr.pincode}
                              </p>
                              {addr.alt_phone && (
                                <p className="address-phone">{addr.alt_phone}</p>
                              )}
                            </div>
                          </label>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div className="acct-no-address-box">No Saved Address</div>
              )}

              {!showAddressForm && (
                <button
                  className="address-btn-primary"
                  onClick={() => setShowAddressForm(true)}
                >
                  + Add New Address
                </button>
              )}

              {/* Address Form Modal */}
              <Modal
                isOpen={showAddressForm}
                onClose={closeAddressFormModal}
              >
                <div className="address-form-container">
                  <h3 className="address-form-title">Add New Address</h3>

                  {addressError && (
                    <div className="error-message">{addressError}</div>
                  )}

                  <div className="address-form-group">
                    <label className="address-form-label required">
                      Address Line 1
                    </label>
                    <input
                      name="address_line1"
                      className="address-form-input"
                      value={addressForm.address_line1}
                      onChange={handleAddressChange}
                      placeholder="Street address, P.O. box"
                    />
                  </div>

                  <div className="address-form-group">
                    <label className="address-form-label">Address Line 2</label>
                    <input
                      name="address_line2"
                      className="address-form-input"
                      value={addressForm.address_line2}
                      onChange={handleAddressChange}
                      placeholder="Apartment, suite, unit, building (optional)"
                    />
                  </div>

                  <div className="address-form-group">
                    <label className="address-form-label required">
                      Emirate
                    </label>
                    <select
                      name="state"
                      className="address-form-input"
                      value={addressForm.state}
                      onChange={(e) => {
                        const emirate = e.target.value;
                        const cities = getCitiesForEmirate(emirate);
                        setAddressForm((prev) => ({
                          ...prev,
                          state: emirate,
                          city: cities[0] || "",
                        }));
                        setAddressError("");
                      }}
                    >
                      <option value="">Select emirate</option>
                      {UAE_EMIRATES.map((emirate) => (
                        <option key={emirate} value={emirate}>
                          {emirate}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="address-form-group">
                    <label className="address-form-label required">City</label>
                    <select
                      name="city"
                      className="address-form-input"
                      value={addressForm.city}
                      onChange={handleAddressChange}
                      disabled={!addressForm.state}
                    >
                      <option value="">Select city</option>
                      {getCitiesForEmirate(addressForm.state).map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="address-form-group">
                    <label className="address-form-label required">
                      Phone Number
                    </label>
                    <PhoneInput
                      country={"ae"}
                      value={addressForm.phone}
                      onChange={handlePhoneChange}
                      inputStyle={{
                        width: "100%",
                        height: "45px",
                        fontSize: "14px",
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        paddingLeft: "58px",
                      }}
                      buttonStyle={{
                        backgroundColor: "#f8f8f8",
                        border: "1px solid #ddd",
                        borderRight: "none",
                        borderRadius: "8px 0 0 8px",
                      }}
                      dropdownStyle={{
                        borderRadius: "8px",
                        border: "1px solid #ddd",
                      }}
                      searchStyle={{
                        borderRadius: "6px",
                        border: "1px solid #ddd",
                      }}
                      preferredCountries={["ae", "in", "us", "gb"]}
                      enableSearch={true}
                      searchPlaceholder="Search country"
                      enableAreaCodes={true}
                      enableAreaCodeStretch={true}
                      countryCodeEditable={true}
                      disableCountryCode={false}
                      disableAreaCodes={false}
                      international={true}
                      defaultCountry={"ae"}
                      masks={{ ae: "(...) ...-...." }}
                    />
                  </div>

                  <div className="address-form-buttons">
                    <button
                      className="address-btn-secondary"
                      onClick={onclickcancel}
                      disabled={isLoading}
                    >
                      Cancel
                    </button>
                    <button
                      className="address-btn-primary"
                      onClick={onclickaddress}
                      disabled={isLoading}
                    >
                      {isLoading ? "Adding..." : "Add Address"}
                    </button>
                  </div>
                </div>
              </Modal>
            </>
          )}

          {/* STEP 3 – PAYMENT */}
          {currentStep === 3 && (
            <>
              <h2>Select Payment Method</h2>

              <div className="payment-options-column">
                <div
                  className={`payment-card ${
                    paymentMethod === "online" ? "active" : ""
                  }`}
                  onClick={() => setPaymentMethod("online")}
                >
                  <input
                    type="radio"
                    name="payment"
                    value="online"
                    checked={paymentMethod === "online"}
                    onChange={() => setPaymentMethod("online")}
                  />
                  <div className="payment-content">
                    <h4>Credit / Debit Card</h4>
                    <p>Pay securely using, Visa, MasterCard or other cards.</p>
                  </div>
                </div>

                <div
                  className={`payment-card ${
                    paymentMethod === "tamara" ? "active" : ""
                  } ${tamaraAvailable !== true ? "payment-card--unavailable" : ""}`}
                  aria-disabled={tamaraAvailable !== true}
                  onClick={() => {
                    if (tamaraAvailable === true) setPaymentMethod("tamara");
                  }}
                >
                  <input
                    type="radio"
                    name="payment"
                    value="tamara"
                    checked={paymentMethod === "tamara"}
                    onChange={() => setPaymentMethod("tamara")}
                    disabled={tamaraAvailable !== true}
                  />
                  <div className="payment-content">
                    <h4>Tamara</h4>
                    <p>{tamaraAvailable === null
                      ? "Checking availability..."
                      : tamaraAvailable
                        ? "Pay securely with Tamara."
                        : "Temporarily unavailable"}</p>
                  </div>
                </div>

                <div
                  className={`payment-card ${paymentMethod === "tabby" ? "active" : ""} ${!tabbySelectable ? "payment-card--unavailable" : ""}`}
                  aria-disabled={!tabbySelectable}
                  onClick={() => { if (tabbySelectable) setPaymentMethod("tabby"); }}
                >
                  <input
                    type="radio"
                    name="payment"
                    value="tabby"
                    checked={paymentMethod === "tabby"}
                    onChange={() => setPaymentMethod("tabby")}
                    disabled={!tabbySelectable}
                  />
                  <div className="payment-content">
                    <h4 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      Pay later with <img src={tabbyBadge} alt="Tabby" style={{ width: "51px", height: "20px" }} />
                    </h4>
                    <p>{tabbyConfig.available === null ? "Checking availability..." : tabbyConfig.available === false ? "Temporarily unavailable" : tabbyEligibility.eligible === false ? tabbyEligibility.message : "Pay in 4 with Tabby."}</p>
                  </div>
                </div>
                {paymentMethod === "tabby" && tabbySelectable && (
                  <TabbyCheckoutCard
                    price={payableTotal ?? pricing.total}
                    publicKey={tabbyConfig.publicKey}
                    merchantCode={tabbyConfig.merchantCode}
                  />
                )}

                {isCodEligible && (
                  <div
                    className={`payment-card ${
                      paymentMethod === "cod" ? "active" : ""
                    }`}
                    onClick={() => setPaymentMethod("cod")}
                  >
                    <input
                      type="radio"
                      name="payment"
                      value="cod"
                      checked={paymentMethod === "cod"}
                      onChange={() => setPaymentMethod("cod")}
                    />
                    <div className="payment-content">
                      <h4>Cash on Delivery</h4>
                      <p>Pay when your order is delivered to your address.</p>
                    </div>
                  </div>
                )}
              </div>

              {shouldShowCodMinimumMessage && (
                <div className="checkout-payment-note">
                  {COD_MINIMUM_ORDER_MESSAGE}
                </div>
              )}

              {(["cod", "online", "tamara", "tabby"].includes(paymentMethod)) && (
                <div className="cod-card">
                  <div className="cod-products-list">
                    {products.map((product) => {
                      const pricingDetails = getDisplayPricing(product);
                      const unitPrice = pricingDetails.originalPrice;
                      const quantity = quantities[product.id] || 1;
                      const productTotal = pricingDetails.finalPrice * quantity;
                      const hasDiscount = unitPrice * quantity > productTotal + 0.005;

                      return (
                        <article key={product.id} className="cod-product">
                          <div className="cod-product__media">
                            <img
                              src={getProductImage(product)}
                              alt={product.name}
                              className="cod-product-img"
                              onError={(event) => {
                                event.currentTarget.src = DEFAULT_PRODUCT_IMAGE;
                              }}
                            />
                          </div>
                          <div className="cod-product-info">
                            <h3>{product.name}</h3>
                            <p>Quantity: {quantity}</p>
                            {pricingDetails.hasOffer ? (
                              <span className="discount-badge">
                                Save AED {numberWithCommas(Number(pricingDetails.discountAmount).toFixed(2))}
                              </span>
                            ) : pricingDetails.discountPercent > 0 ? (
                              <span className="discount-badge">
                                {pricingDetails.discountPercent}% OFF
                              </span>
                            ) : null}
                          </div>
                          <div className="cod-product__price">
                            <span className="cod-product__price-label">Item total</span>
                            <strong className="cod-product__amount">
                              <AmountWithDirham amount={productTotal} />
                            </strong>
                            {hasDiscount && (
                              <s className="cod-product__original">
                                <AmountWithDirham amount={unitPrice * quantity} />
                              </s>
                            )}
                          </div>
                        </article>
                      );
                    })}
                  </div>

                  <div className="cod-summary">
                    <div className="summary-line">
                      <span>Subtotal ({products.length} items)</span>
                      <AmountWithDirham amount={pricing.subtotal} />
                    </div>

                    <div className="summary-line">
                      <span>Delivery Charge</span>
                      {renderSummaryAmount(deliveryCharge)}
                    </div>

                    <div className="summary-total">
                      <span>Total Payable</span>
                      {renderSummaryAmount(payableTotal)}
                    </div>
                  </div>

                  <button
                    className="confirm-order-btn"
                    onClick={handleConfirmOrder}
                    disabled={
                      isLoading ||
                      hasCheckoutStockIssue ||
                      (paymentMethod === "tamara" && tamaraAvailable !== true)
                      || (paymentMethod === "tabby" && !tabbySelectable)
                    }
                  >
                    {isLoading
                      ? paymentMethod === "cod" ? "Placing Order..." : "Redirecting..."
                      : `${paymentMethod === "cod" ? "Confirm Order" : "Pay Now"} (${products.length} items)`}
                  </button>
                </div>
              )}
            </>
          )}
        </div>

        {/* RIGHT SECTION – ORDER TOTAL */}
        {(!isMobile || (isMobile && currentStep !== 3)) && (
          <div className="checkout-right">
            <h3>Order Total ({products.length} items)</h3>

            <div className="summary-row">
              <span>Original Price</span>
              <AmountWithDirham amount={pricing.originalTotal} />
            </div>

            <div className="summary-row">
              <span>Total Discount</span>
              <AmountWithDirham
                amount={pricing.totalDiscount}
                negative
                className="discount"
              />
            </div>

            <div className="summary-row">
              <span>Subtotal</span>
              <AmountWithDirham amount={pricing.subtotal} />
            </div>

            <div className="summary-row">
              <span>Delivery Charge</span>
              {renderSummaryAmount(deliveryCharge)}
            </div>

            <div className="summary-divider" />

            <div className="summary-total">
              <span>Total Payable</span>
              {renderSummaryAmount(payableTotal)}
            </div>

            {currentStep === 1 && (
              <button
                className="pay-btn"
                onClick={() => setCurrentStep(2)}
                disabled={hasCheckoutStockIssue}
              >
                Next
              </button>
            )}

            {currentStep === 2 && (
              <button
                className="pay-btn"
                onClick={handleNextToPayment}
                disabled={hasCheckoutStockIssue}
              >
                Next
              </button>
            )}
          </div>
        )}
      </div>

      {/* Mobile Bottom Button for Step 3 */}
      {isMobile && currentStep === 3 && (
        <div className="mobile-bottom-button">
          <button
            className="confirm-order-btn mobile-confirm-btn"
            onClick={handleConfirmOrder}
            disabled={
              isLoading ||
              hasCheckoutStockIssue ||
              (paymentMethod === "tamara" && tamaraAvailable !== true)
              || (paymentMethod === "tabby" && !tabbySelectable)
            }
          >
            {isLoading
              ? ["online", "tamara", "tabby"].includes(paymentMethod)
                ? "Redirecting..."
                : "Placing Order..."
              : (
                <>
                  {["online", "tamara", "tabby"].includes(paymentMethod)
                    ? "Pay Now"
                    : "Confirm Order"} -
                  {" "}
                  <AmountWithDirham amount={payableTotal ?? pricing.total} />
                </>
              )}
          </button>
        </div>
      )}

      {/* Suggested Products Section - MOVED TO BOTTOM */}
      {similarproductdata && similarproductdata.length > 0 && (
        <div className="checkout-suggested-section-bottom">
          <div className="checkout-suggested-header">
            <h3>You might also like</h3>
            <p>Based on items in your cart</p>
          </div>

          <div className="suggested-scroll-wrapper">
            <button
              className={`suggested-scroll-btn left ${!showLeftArrow ? "disabled" : ""}`}
              onClick={() => scrollSuggested("left")}
              disabled={!showLeftArrow}
              aria-label="Scroll left"
            >
              <FaChevronLeft />
            </button>

            <div
              className="suggested-scroll-container"
              ref={scrollContainerRef}
              onScroll={checkScrollArrows}
            >
              <div className="suggested-products-row">
                {similarproductdata.map((product) => (
                  <SuggestedProductCard key={product.id} product={product} />
                ))}
              </div>
            </div>

            <button
              className={`suggested-scroll-btn right ${!showRightArrow ? "disabled" : ""}`}
              onClick={() => scrollSuggested("right")}
              disabled={!showRightArrow}
              aria-label="Scroll right"
            >
              <FaChevronRight />
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

/* =========================
   REDUX
========================= */
const mapStateToProps = (state) => ({
  getproductbyiddata: state.Home.getproductbyiddata?.data,
  getaddressData: state.Account.getaddressData,
  addAddressData: state.Account.addAddressData,
  similarproductdata: state.Home.getsimilarproductdata?.data,
  addcartdata: state.Home.Cartdata,
});

const mapDispatchToProps = (dispatch) => ({
  getproductbyidRequest: (data) => dispatch(getproductbyidRequest(data)),
  getsimilarproductdataRequest: (data) =>
    dispatch(getsimilarproductdataRequest(data)),
  getaddressRequest: () => dispatch(getaddressRequest()),
  addAddressRequest: (data) => dispatch(addAddressRequest(data)),
  getCartRequest: () => dispatch(getCartRequest()),
  insertCartRequest: (data) => dispatch(insertCartRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
